import { UserLevel } from 'src/State/User/UserModel'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

interface UseUserHelpersHook {
  getUserLevelDisplayName(value: UserLevel): string
}

/**
 * The hook provides some ui utils to mutate or generate data for the User model
 */
const useUserHelpers = (): UseUserHelpersHook => {
  const { t } = useCustomTranslation()
  const getUserLevelDisplayName = (value: UserLevel): string => t(`framework.userBadge.userlevel.${value}`)

  return { getUserLevelDisplayName }
}

export default useUserHelpers
